import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _pt from '../../node_modules/prop-types/index.js';
import React from 'react';
import { getBuilderComponentOptions } from './config.js';
import ListBase$1 from './base/ListBase.js';
import { createAutoName } from '../../modules/utility/naming.js';

var _excluded = ["withTable", "loadable", "renderList", "renderLoading", "renderError"];
/**
 * A helper to load data and manage state for a list or table
 */

var ListBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits(ListBuilder, _React$Component);

  var _super = _createSuper(ListBuilder);

  function ListBuilder(props) {
    var _this;

    _classCallCheck(this, ListBuilder);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "listWithData", function (data, state, events) {
      var _ref = _this.props,
          renderList = _ref.renderList;
      return renderList(data, state, events);
    });

    _defineProperty(_assertThisInitialized(_this), "listWithTable", function (tableProps, state, events) {
      var _ref2 = _this.props,
          renderList = _ref2.renderList;
      return renderList(tableProps, state, events);
    });

    _defineProperty(_assertThisInitialized(_this), "listWithTiles", function (tileProps, state, events) {
      var _ref3 = _this.props,
          renderList = _ref3.renderList;
      return renderList(tileProps, state, events);
    });

    _defineProperty(_assertThisInitialized(_this), "renderDefaultList", function (data, state, events) {
      var _this$props = _this.props,
          withTable = _this$props.withTable,
          withTiles = _this$props.withTiles;

      if (withTable) {
        return _this.listWithTable({
          data: data
        }, state, events);
      }

      if (withTiles) {
        return _this.listWithTiles({
          data: data
        }, state, events);
      }

      return _this.listWithData(data, state, events);
    });

    _defineProperty(_assertThisInitialized(_this), "renderLoadableList", function (data, state, events) {
      var _this$props2 = _this.props,
          withTable = _this$props2.withTable,
          withTiles = _this$props2.withTiles,
          loadable = _this$props2.loadable,
          renderLoading = _this$props2.renderLoading,
          renderError = _this$props2.renderError;
      var loadableProps = {};

      if (state.loading) {
        if (renderLoading) return renderLoading(state.slowLoading);

        if (renderLoading !== false) {
          loadableProps.loading = true;
          loadableProps.slowLoading = state.slowLoading;
        }
      }

      if (state.error) {
        if (renderError) return renderError(state.error);

        if (renderError !== false) {
          loadableProps.error = state.error;
        }
      }

      if (withTable) {
        return _this.listWithTable(_objectSpread2(_objectSpread2({}, loadableProps), {}, {
          data: data
        }), state, events);
      }

      if (withTiles) {
        return _this.listWithTiles(_objectSpread2(_objectSpread2({}, loadableProps), {}, {
          data: data
        }), state, events);
      }

      var LoadableComponent = loadable || getBuilderComponentOptions().defaultLoadable;
      return /*#__PURE__*/React.createElement(LoadableComponent, loadableProps, _this.listWithData(data, state, events));
    });

    var id = props.id;

    if (!id) {
      id = createAutoName("list/");
    }

    _this.state = {
      id: id
    };
    return _this;
  }

  _createClass(ListBuilder, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props;
      _this$props3.withTable;
      _this$props3.loadable;
      _this$props3.renderList;

      var renderLoading = _this$props3.renderLoading,
          renderError = _this$props3.renderError,
          otherProps = _objectWithoutProperties(_this$props3, _excluded);

      return /*#__PURE__*/React.createElement(ListBase$1, _extends({}, otherProps, {
        id: this.state.id,
        render: function render() {
          return renderLoading === false && renderError === false ? _this2.renderDefaultList.apply(_this2, arguments) : _this2.renderLoadableList.apply(_this2, arguments);
        }
      }));
    }
  }]);

  return ListBuilder;
}(React.Component);

_defineProperty(ListBuilder, "propTypes", {
  id: _pt.string,
  withTable: _pt.any,
  withTiles: _pt.any,
  renderList: _pt.func.isRequired,
  renderLoading: _pt.oneOfType([_pt.func, _pt.oneOf([false])]),
  renderError: _pt.oneOfType([_pt.func, _pt.oneOf([false])]),
  initialData: _pt.any,
  initialFilters: _pt.any,
  initialPagination: _pt.any,
  initialSelection: _pt.any,
  dataTransform: _pt.func,
  totalTransform: _pt.func,
  loadAction: _pt.func,
  loadParams: _pt.any,
  loadTransform: _pt.func,
  loadSlowDelay: _pt.number,
  onLoad: _pt.func,
  onLoaded: _pt.func,
  loadable: _pt.elementType,
  persistFilters: _pt.string,
  debounceFilters: _pt.number,
  debouncePagination: _pt.number
});

_defineProperty(ListBuilder, "defaultProps", {
  withTable: false,
  withTiles: false,
  initialFilters: {},
  initialPagination: {
    pageSize: 10,
    pageNumber: 1
  },
  initialSelection: {},
  dataTransform: function dataTransform(data) {
    return data;
  },
  totalTransform: function totalTransform(data) {
    return data.length;
  },
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200,
  debounceFilters: 250,
  debouncePagination: -250
});

var ListBuilder$1 = ListBuilder;

export { ListBuilder$1 as default };
